import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../../services/api';
import { CalendarPost, SocialAccount } from '../../types/api';
import { PLATFORM_NAMES } from './AccountChoices';

export default function RetryDestinations({ post, accounts, onQueued }: {
  post: CalendarPost;
  accounts: SocialAccount[];
  onQueued: (post: CalendarPost) => void;
}) {
  const remaining = accounts.filter((a) => post.remaining_account_ids.includes(a.id));
  const [selected, setSelected] = useState(remaining.filter((a) => a.is_active && !a.connection_warning).map((a) => a.id));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const succeeded = new Set(post.publish_results?.filter((r) => r.ok).map((r) => r.account));
  async function retry() {
    setBusy(true); setError('');
    try {
      onQueued(await apiClient.post<CalendarPost>('/posts/calendar/retry/', { post_id: post.id, account_ids: selected }));
    } catch (err) { setError((err as Error).message); }
    finally { setBusy(false); }
  }
  return <section className="panel calendar-retry">
    <h3>Send to remaining accounts</h3>
    {succeeded.size > 0 && <p className="muted">Already delivered to {succeeded.size} account{succeeded.size === 1 ? '' : 's'}. Those accounts will not receive it again.</p>}
    {remaining.map((account) => <label className="calendar-retry-choice" key={account.id}>
      <input type="checkbox" checked={selected.includes(account.id)} disabled={busy || !account.is_active || !!account.connection_warning}
        onChange={() => setSelected((ids) => ids.includes(account.id) ? ids.filter((id) => id !== account.id) : [...ids, account.id])} />
      <span>{PLATFORM_NAMES[account.platform] || account.platform}: {account.account_name}
        {(!account.is_active || account.connection_warning) && <small className="muted"> — reconnect required</small>}
      </span>
    </label>)}
    {remaining.some((a) => !a.is_active || a.connection_warning) && <Link to="/accounts">Reconnect accounts</Link>}
    {error && <p className="banner banner--error" role="alert">{error}</p>}
    <button className="btn btn--primary" disabled={busy || !selected.length} onClick={retry}>
      {busy ? 'Queuing…' : 'Send to selected accounts'}
    </button>
  </section>;
}
